/**
 * "Your Privacy Choices" (footer): opens the Ketch preferences modal.
 *
 * The Ketch tag in header.php defines window.ketch as a queue right away and replays the
 * queued calls once boot.js loads, so a click before Ketch finishes loading still works.
 * Delegated from the document, so it doesn't wait for window load.
 */
export function ketchPreferencesInit() {
	document.addEventListener( 'click', function( event ) {
		const button = event.target.closest( '.js-ketch-preferences' );
		if ( ! button || typeof window.ketch !== 'function' ) {
			return;
		}

		event.preventDefault();
		window.ketch( 'showPreferences' );
	} );
}
